module.exports = __webpack_public_path__ + "img/line3.7bd3f4ff.svg";